import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import axios from "axios";
import md5 from "md5";
import Swal from "sweetalert2";
import { BsPersonCircle } from "react-icons/bs";
import { FaSignOutAlt, FaKey, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/Personalizado.css";

function Header() {
  const navigate   = useNavigate();
  const cookies    = new Cookies();
  const location   = useLocation();
  const baseURL    = process.env.REACT_APP_API_BASE_URL;

  const [nombre,   setNombre]   = useState("");
  const [perfil,   setPerfil]   = useState("");
  const [correo,   setCorreo]   = useState("");
  const [usuario,  setUsuario]  = useState("");

  // Modal perfil
  const [modalPerfil,    setModalPerfil]    = useState(false);
  // Modal contraseña
  const [modalClave,     setModalClave]     = useState(false);
  const [nuevaClave,     setNuevaClave]     = useState("");
  const [confirmarClave, setConfirmarClave] = useState("");
  const [verNueva,       setVerNueva]       = useState(false);
  const [verConfirmar,   setVerConfirmar]   = useState(false);
  const [loadingClave,   setLoadingClave]   = useState(false);

  useEffect(() => {
    if (!cookies.get("idUsuario")) {
      navigate("/");
    } else {
      setNombre(cookies.get("nombresApellidos") || "");
      setPerfil(cookies.get("perfil")           || "");
      setCorreo(cookies.get("correo")           || "");
      setUsuario(cookies.get("nombreUsuario")   || "");
    }
  }, [location]);

  // ─── Cerrar sesión ──────────────────────────────────────────────────────────
  const cerrarSesion = () => {
    ["idUsuario","nombreUsuario","nombresApellidos","correo","perfilId","perfil"]
      .forEach(k => cookies.remove(k, { path: "/" }));
    navigate("/");
  };

  // ─── Formatear nombre ───────────────────────────────────────────────────────
  const formatName = (name) => {
    if (!name) return "";
    return name.toLowerCase().split(" ")
      .map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
  };

  // ─── Cambiar contraseña ─────────────────────────────────────────────────────
  const guardarContrasena = async () => {
    if (!nuevaClave) {
      Swal.fire({ toast: true, icon: "warning", title: "Ingresa la nueva contraseña.",
        position: "top-end", showConfirmButton: false, timer: 3000, timerProgressBar: true });
      return;
    }
    if (nuevaClave.length < 6) {
      Swal.fire({ toast: true, icon: "warning", title: "Mínimo 6 caracteres.",
        position: "top-end", showConfirmButton: false, timer: 3000, timerProgressBar: true });
      return;
    }
    if (nuevaClave !== confirmarClave) {
      Swal.fire({ toast: true, icon: "error", title: "Las contraseñas no coinciden.",
        position: "top-end", showConfirmButton: false, timer: 3000, timerProgressBar: true });
      return;
    }

    setLoadingClave(true);
    try {
      await axios.post(`${baseURL}/api/Usuarios/CambiarContrasena`, {
        nombreUsuario: usuario,
        contrasena:    md5(nuevaClave),
      });
      Swal.fire({ toast: true, icon: "success", title: "Contraseña actualizada correctamente.",
        position: "top-end", showConfirmButton: false, timer: 3000, timerProgressBar: true });
      setModalClave(false);
      setNuevaClave("");
      setConfirmarClave("");
    } catch {
      Swal.fire({ toast: true, icon: "error", title: "No se pudo cambiar la contraseña.",
        position: "top-end", showConfirmButton: false, timer: 3000, timerProgressBar: true });
    } finally {
      setLoadingClave(false);
    }
  };

  const abrirModalClave = () => {
    setNuevaClave("");
    setConfirmarClave("");
    setVerNueva(false);
    setVerConfirmar(false);
    setModalPerfil(false);
    setModalClave(true);
  };

  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Botón hamburguesa */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>

        {/* Derecha */}
        <ul className="navbar-nav ml-auto align-items-center">
          <li className="user-info">
            {/* Nombre clickeable → abre modal perfil */}
            <span
              className="username"
              style={{ cursor: "pointer" }}
              onClick={() => setModalPerfil(true)}
              title="Ver perfil"
            >
              <BsPersonCircle style={{ fontSize: "1.5rem", marginRight: "6px" }} />
              {formatName(nombre)}
            </span>
            <button className="btn btn-sm btn-logout" onClick={cerrarSesion}>
              <FaSignOutAlt className="mr-1" />
              Cerrar sesión
            </button>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-widget="fullscreen" href="#" role="button">
              <i className="fas fa-expand-arrows-alt" />
            </a>
          </li>
        </ul>
      </nav>

      {/* ═══════════════════════════════════════════════════════
          MODAL PERFIL
      ═══════════════════════════════════════════════════════ */}
      {modalPerfil && (
        <div className="hdr-modal-overlay" onClick={() => setModalPerfil(false)}>
          <div className="hdr-modal" onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div className="hdr-modal-header">
              <h5 className="hdr-modal-title">👤 Mi perfil</h5>
              <button className="hdr-modal-close" onClick={() => setModalPerfil(false)}>×</button>
            </div>

            {/* Body */}
            <div className="hdr-modal-body">
              {/* Avatar */}
              <div className="hdr-avatar-wrap">
                <div className="hdr-avatar">
                  {formatName(nombre).charAt(0) || "U"}
                </div>
                <div>
                  <div className="hdr-avatar-name">{formatName(nombre)}</div>
                  <span className={`hdr-badge-perfil ${perfil === "Administrador" ? "hdr-badge-admin" : "hdr-badge-estandar"}`}>
                    {perfil}
                  </span>
                </div>
              </div>

              {/* Datos */}
              <div className="hdr-info-grid">
                <div className="hdr-info-item">
                  <span className="hdr-info-label"><i className="fas fa-user mr-1"></i>Usuario</span>
                  <span className="hdr-info-value">{usuario}</span>
                </div>
                <div className="hdr-info-item">
                  <span className="hdr-info-label"><i className="fas fa-envelope mr-1"></i>Correo</span>
                  <span className="hdr-info-value">{correo || "—"}</span>
                </div>
                <div className="hdr-info-item">
                  <span className="hdr-info-label"><i className="fas fa-id-badge mr-1"></i>Nombre completo</span>
                  <span className="hdr-info-value">{formatName(nombre) || "—"}</span>
                </div>
                <div className="hdr-info-item">
                  <span className="hdr-info-label"><i className="fas fa-shield-alt mr-1"></i>Rol</span>
                  <span className="hdr-info-value">{perfil || "—"}</span>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="hdr-modal-footer">
              <button className="hdr-btn-cancelar" onClick={() => setModalPerfil(false)}>
                Cerrar
              </button>
              <button className="hdr-btn-clave" onClick={abrirModalClave}>
                <FaKey style={{ marginRight: 6 }} /> Cambiar contraseña
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ═══════════════════════════════════════════════════════
          MODAL CAMBIAR CONTRASEÑA
      ═══════════════════════════════════════════════════════ */}
      {modalClave && (
        <div className="hdr-modal-overlay" onClick={() => setModalClave(false)}>
          <div className="hdr-modal" onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div className="hdr-modal-header">
              <h5 className="hdr-modal-title">🔒 Cambiar contraseña</h5>
              <button className="hdr-modal-close" onClick={() => setModalClave(false)}>×</button>
            </div>

            {/* Body */}
            <div className="hdr-modal-body">
              <p className="hdr-info-label mb-3">
                Cambiando contraseña de: <strong>{usuario}</strong>
              </p>

              {/* Nueva contraseña */}
              <div className="hdr-form-group">
                <label className="hdr-label">Nueva contraseña <span className="text-danger">*</span></label>
                <div className="hdr-input-group">
                  <input
                    type={verNueva ? "text" : "password"}
                    className="hdr-input"
                    autoComplete="new-password"
                    placeholder="Mínimo 6 caracteres"
                    value={nuevaClave}
                    onChange={e => setNuevaClave(e.target.value)}
                  />
                  <button className="hdr-eye-btn" type="button" onClick={() => setVerNueva(!verNueva)}>
                    {verNueva ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {/* Confirmar contraseña */}
              <div className="hdr-form-group">
                <label className="hdr-label">Confirmar contraseña <span className="text-danger">*</span></label>
                <div className="hdr-input-group">
                  <input
                    type={verConfirmar ? "text" : "password"}
                    className="hdr-input"
                    autoComplete="new-password"
                    placeholder="Repite la contraseña"
                    value={confirmarClave}
                    onChange={e => setConfirmarClave(e.target.value)}
                    onKeyDown={e => e.key === "Enter" && guardarContrasena()}
                  />
                  <button className="hdr-eye-btn" type="button" onClick={() => setVerConfirmar(!verConfirmar)}>
                    {verConfirmar ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {/* Indicador coincidencia */}
              {confirmarClave && (
                <p style={{ fontSize: "0.8rem", marginTop: "-4px",
                  color: nuevaClave === confirmarClave ? "#28a745" : "#dc3545" }}>
                  {nuevaClave === confirmarClave ? "✔ Las contraseñas coinciden" : "✖ No coinciden"}
                </p>
              )}
            </div>

            {/* Footer */}
            <div className="hdr-modal-footer">
              <button className="hdr-btn-cancelar" onClick={() => setModalClave(false)}>
                Cancelar
              </button>
              <button className="hdr-btn-guardar" onClick={guardarContrasena} disabled={loadingClave}>
                {loadingClave
                  ? <><span className="spinner-border spinner-border-sm mr-1"></span> Guardando...</>
                  : <><FaKey style={{ marginRight: 6 }} /> Guardar</>
                }
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;